import {Component, Input} from "@angular/core";
import {BIService} from "../../framework/bi/bi.service";
import {BIAttribute} from "./bi-attribute";

@Component({
    selector: "wbo-bi-draggable-attributes-list",
    templateUrl: "./draggable-attributes-list.component.html",
    providers: [BIService]
})
export class DraggableAttributesListComponent {

    @Input() title: string;

    @Input() attributes: BIAttribute[];
}
